import { render, staticRenderFns } from "./VariantView.vue?vue&type=template&id=3b69e1f5"
import script from "./VariantView.vue?vue&type=script&lang=js"
export * from "./VariantView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports